<template>
    <div class="card row cardBemVindo">
        <div class="col-12">
            <h4>{{ $t('TOP 20 Placas com mais OS') }}</h4>
            <p>{{ $t('Últimos 30 dias') }}</p>
            <table class="table table-responsive" style="height: 410px; overflow: auto!important;">
                <thead>
                    <tr>
                        <th scope="col">{{ $t('Placa') }}</th>
                        <th scope="col">{{ $t('Qtd OS') }}</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(placa, index) in getPlacasOs" :key="index">
                        <th scope="row">{{ placa.nr_placa }}</th>
                        <td>{{ placa.total_os }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

  computed: {
    getPlacasOs(){
        const placas =  this.$store.getters['dashboard/getPlacasOs'];
        
        if(!placas){
            this.$store.dispatch('dashboard/getPlacasOs')

            return []
        }
        return placas.placa_os
    }
  },

  mounted() {
    this.$store.dispatch('dashboard/getPlacasOs')
  },

  methods: {
    
  }
}
</script>
<style scoped>
    .cardBemVindo {
        flex-direction: row;
        align-items: flex-end;
        margin-right: 10px;
    }

    canvas {
        height: 400px;
        /* Define a altura fixa para o gráfico */
        width: 100%;
        /* Ocupar toda a largura disponível */
    }
</style>